import React from 'react';
import { Star, MapPin, Scale, Map, Lock } from 'lucide-react';
const ITEMS = [{
  icon: Star,
  label: '5 Star Google Rating'
}, {
  icon: MapPin,
  label: 'Carlton, Melbourne office'
}, {
  icon: Scale,
  label: 'Qualified solicitors'
}, {
  icon: Map,
  label: 'Victoria-wide service'
}, {
  icon: Lock,
  label: 'Confidential document handling'
}];
export function TrustBar() {
  return <section className="px-5 md:px-6 pb-4 md:pb-8 bg-background" data-id="element-413">
      <div className="max-w-7xl mx-auto" data-id="element-414">
        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px rounded-2xl overflow-hidden border border-border bg-border" data-id="element-415">
          {ITEMS.map(item => {
          const Icon = item.icon;
          return <li key={item.label} className="flex items-center justify-center gap-2.5 bg-surface px-4 py-4 text-center" data-id="element-416">
                <Icon className="w-4 h-4 text-accent shrink-0" data-id="element-417" />
                <span className="text-xs md:text-sm font-medium text-ink leading-snug" data-id="element-418">
                  {item.label}
                </span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}